// import { all, call, put, takeLatest } from 'redux-saga/effects';
// import axios from 'axios';

// import { fetchThemeSuccess, fetchThemeFail } from './actions';

// import { FETCH_THEME_REQUEST } from './actionTypes';

// import { logout } from '../Auth/actions';
// import { getOptions, processResponse } from '../../Utils/Utils';

// const fetchThemeUrl = () => `/users/info`;

// // Moved api call into own function (for easy test swapping)
// export function fetchFromApi(options) {
//   return axios(options)
//     .then(response => ({ response }))
//     .catch(error => ({ error }));
// }

// function* fetchTheme() {
//   const { response, error } = yield call(fetchFromApi, getOptions({ url: fetchThemeUrl() }));
//   const { type, data, alerts } = processResponse({ response, error });

//   switch (type) {
//     case 'success':
//       yield put(fetchThemeSuccess({ data }));
//       break;
//     case 'fail':
//       yield put(fetchThemeFail({ error: alerts }));
//       break;
//     case 'logout':
//       yield put(logout());
//       break;
//     default:
//       break;
//   }
// }

function* watchThemes() {
  // yield all([yield takeLatest(FETCH_THEME_REQUEST, fetchTheme)]);
}

export default watchThemes;
